import {
  BrightyListItem,
  CompactGridItem,
  ListContentIsland,
  EditDetailsListItem,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { useAppearanceSetting } from '../../../hooks/useThemeMode';
import { useCustomerQuery } from '../../../api/customers';
import { useMemo } from 'react';
import { useBusinessQuery } from '../../../api/businesses';

export function SettingsPage() {
  const { t } = useTranslation();
  const businessQuery = useBusinessQuery();
  const customerQuery = useCustomerQuery();
  const identity = customerQuery.data?.identity;
  const individual = customerQuery.data?.individual;
  const [appearance, setAppearance] = useAppearanceSetting();

  const isPhoneAvailable = businessQuery.data?.profile.state === 'ACTIVE';
  const isAccountSecure = Boolean(identity?.email && identity.phone && identity.hasPassword);

  const name = useMemo(
    () => [individual?.name?.firstName, individual?.name?.lastName].filter(Boolean).join(' '),
    [individual?.name?.firstName, individual?.name?.lastName],
  );

  return (
    <MainLayout title={t('Settings')}>
      <CompactGridItem>
        <ListContentIsland title={t('Personal information')}>
          <EditDetailsListItem
            label={t('Name')}
            value={name}
            setLabel={t('Set name')}
            editLabel={t('Edit name')}
            editLink={{ to: '/account/settings/name' }}
            loading={customerQuery.isPending}
          />
          <EditDetailsListItem
            label={t('Email')}
            value={identity?.email}
            setLabel={t('Set email')}
            editLabel={t('Edit email')}
            editLink={{ to: '/account/settings/email' }}
            loading={customerQuery.isPending}
          />
          {isPhoneAvailable ? (
            <EditDetailsListItem
              label={t('Phone')}
              value={identity?.phone}
              setLabel={t('Set phone')}
              editLabel={t('Edit phone')}
              editLink={{ to: '/account/settings/phone' }}
              loading={customerQuery.isPending}
            />
          ) : null}
        </ListContentIsland>
      </CompactGridItem>
      <CompactGridItem>
        <ListContentIsland title={t('Appearance')}>
          <BrightyListItem
            title={t('Light mode')}
            checked={appearance === 'light'}
            onClick={() => setAppearance('light')}
          />
          <BrightyListItem
            title={t('Dark mode')}
            checked={appearance === 'dark'}
            onClick={() => setAppearance('dark')}
          />
          <BrightyListItem
            title={t('Use system theme')}
            checked={appearance === 'system'}
            onClick={() => setAppearance('system')}
          />
        </ListContentIsland>
      </CompactGridItem>
      {isPhoneAvailable ? (
        <CompactGridItem>
          <ListContentIsland title={t('Security')}>
            {isAccountSecure ? (
              <>
                <BrightyListItem<'a'>
                  title={identity?.hasPassword ? t('Change password') : t('Set password')}
                  href="/account/settings/password"
                />
                <BrightyListItem<'a'>
                  title={identity?.email ? t('Change email') : t('Set email')}
                  href="/account/settings/email"
                />
                <BrightyListItem<'a'>
                  title={identity?.phone ? t('Change phone') : t('Set phone')}
                  href="/account/settings/phone"
                />
              </>
            ) : (
              <BrightyListItem<'a'> title={t('Secure account')} href="/account/settings/2fa" />
            )}
          </ListContentIsland>
        </CompactGridItem>
      ) : null}
    </MainLayout>
  );
}
